import styled from 'styled-components';
import { color, container, fontWeight, radius, screen, spacing } from 'theme';

export const StyledSection = styled.div`
  background-color: ${color('indigo_500')};
  color: ${color('text_white')};
  text-align: center;
  padding: ${spacing('xl4')} ${spacing('md')};
  margin: ${spacing('xl4')} -${spacing('md')};
`;

export const StyledContainer = styled.div`
  max-width: ${container('lg')};
  margin: auto;
`;

export const StyledItems = styled.ul`
  max-width: ${container('md')};
  margin: ${spacing('xl2')} auto 0;
  display: grid;
  grid-template-columns: 1fr;
  gap: ${spacing('md')};
  list-style: none;

  @media (min-width: ${screen('md')}) {
    grid-template-columns: 1fr 1fr;
    gap: ${spacing('xl')};
  }
`;

export const StyledItem = styled.li`
  background-color: ${color('indigo_300')};
  padding: 1.25rem;
  border-radius: ${radius('md')};
  display: flex;
  align-items: center;
  gap: 1.25rem;

  img {
    width: 3.5rem;
    height: 3.5rem;
    display: block;
  }
`;

export const StyledRole = styled.span`
  color: ${color('text_default')};
  font-weight: ${fontWeight('medium')};
  line-height: 1.25;
  position: relative;
  margin-top: ${spacing('xs')};

  &::before {
    content: '';
    position: absolute;
    top: -${spacing('xs')};
    left: 0;
    height: ${spacing('xs2')};
    width: ${spacing('xl')};
    background-color: ${color('indigo_500')};
  }
`;
